import { SettingsAiPreferencesSection } from "@/components/settings/SettingsAiPreferencesSection";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/ai-rules")({
  component: SettingsAiPreferencesSection,
});
